import axiosApiClient from '..';
import { handleError, throwErrorIfWrongStatus } from './utils';

const BASE_URL = '/d/crm-analytics';

const postAnalyticsRequest = async ({ endpoint, requestData, defaultErrorMessage }) => {
  try {
    const response = await axiosApiClient.post(`${BASE_URL}${endpoint}`, requestData);
    throwErrorIfWrongStatus(response, 200);
    return { data: response.data.data };
  } catch (err) {
    throw handleError(err, defaultErrorMessage);
  }
};

class OrganizationAnalyticsService {
  fetchInfluencerEarningsByContentTypeByTime = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/influencer/by-time/earnings-by-content-type',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching influencer earnings by content type over time.',
    });
  };

  fetchInfluencerEarningsByContentTypeByInfluencer = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/influencer/by-influencer/earnings-by-content-type',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching influencer earnings by content type by influencer.',
    });
  };

  fetchInfluencerEarningsByMessageTypeByTime = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/influencer/by-time/earnings-by-message-type',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching influencer earnings by message type over time.',
    });
  };

  fetchInfluencerEarningsByMessageTypeByInfluencer = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/influencer/by-influencer/earnings-by-message-type',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching influencer earnings by message type by influencer.',
    });
  };

  fetchInfluencerNewUsersByTime = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/influencer/by-time/new-users',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching influencer new users over time.',
    });
  };

  fetchInfluencerUserInfluencersByTime = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/influencer/by-time/user-influencers',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching influencer user-influencers over time.',
    });
  };

  fetchInfluencerUserInfluencersByInfluencer = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/influencer/by-influencer/user-influencers',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching influencer user-influencers by influencer.',
    });
  };

  fetchInfluencerTableData = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/influencer/table-data',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching influencer table data.',
    });
  };

  fetchChatterTotalEarningsByTime = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/by-time/total-earnings',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter total earnings over time.',
    });
  };

  fetchChatterTotalEarningsByChatter = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/by-chatter/total-earnings',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter total earnings by chatter.',
    });
  };

  fetchChatterTotalMessagesByChatter = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/by-chatter/total-messages',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter total messages by chatter.',
    });
  };

  fetchChatterTotalMessagesByTime = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/by-time/total-messages',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter total messages over time.',
    });
  };

  fetchChatterTotalChatsByChatter = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/by-chatter/total-chats',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter total chats by chatter.',
    });
  };

  fetchChatterTotalChatsByTime = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/by-time/total-chats',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter total chats over time.',
    });
  };

  fetchChatterAverageResponseTimeByChatter = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/by-chatter/average-response-time',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter average response time by chatter.',
    });
  };

  fetchChatterAverageResponseTimeByTime = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/by-time/average-response-time',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter average response time over time.',
    });
  };

  fetchChatterManualVsAiByTime = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/by-time/manual-vs-ai',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter manual vs AI analytics over time.',
    });
  };

  fetchChatterManualVsAiByChatter = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/by-chatter/manual-vs-ai',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter manual vs AI analytics by chatter.',
    });
  };

  fetchChatterPpvRateByTime = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/by-time/ppv-rate',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter conversion rate over time.',
    });
  };

  fetchChatterPpvRateByChatter = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/by-chatter/ppv-rate',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter conversion rate by chatter.',
    });
  };

  fetchChatterTableData = async requestData => {
    return await postAnalyticsRequest({
      endpoint: '/chatter/table-data',
      requestData,
      defaultErrorMessage: 'Error occurred while fetching chatter table data.',
    });
  };
}

export default new OrganizationAnalyticsService();
